import { FormikValues, useFormikContext } from "formik";

import { ComponentPropsWithoutRef } from "react";

import PillarFormInputWrapper, {
  PillarFormInputWrapperProps,
} from "./PillarFormInputWrapper";

export type PillarFormDateInputProps = PillarFormInputWrapperProps &
  Omit<ComponentPropsWithoutRef<"input">, "id" | "name" | "value" | "type">;

//TODO: The only difference between this and PillarFormTextInput is the `type="date"` property.
//We should just use text input and allow a type to be passed to avoid code duplication.
const PillarFormExpirationDateInput = ({
  name,
  label,
  labelClassName,
  additionalClasses,
  className,
  testid,
  onChange,
  ...props
}: PillarFormDateInputProps) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    const sanitizedInput = input.replace(/[^0-9]/g, "");

    if (sanitizedInput.length <= 4) {
      setFieldValue(
        name,
        sanitizedInput.replace(/(\d{2})(\d{0,2})/, "$1/$2").substring(0, 5)
      );
    }
  };

  return (
    <PillarFormInputWrapper
      name={name}
      labelClassName={labelClassName}
      label={label}
      additionalClasses={additionalClasses ?? ""}
    >
      <input
        type="text"
        className={className ?? ""}
        value={values[name] ?? ""}
        name={name}
        data-testid={testid}
        id={name}
        maxLength={5}
        onChange={(e) => handleDateChange(e)}
        {...props}
      />
    </PillarFormInputWrapper>
  );
};

export default PillarFormExpirationDateInput;
